<template>
  <div
    class="the-trophy-component"
    data-help="Du erhältst für jede abgeschlossene Fragenkategorie eine Trophäe."
    data-help-title="Trophäen"
  >
    <h2>Trophäen für gelernte Fragen</h2>
    <div class="trophy-list-container">
      <div v-for="(s, name) in me.trophy_data" :key="name" class="trophy">
        <Trophy :title="name" :unlocked="s.unlocked" @click="goto(s)" />
      </div>
    </div>
  </div>
</template>

<script>
import Trophy from "@/components/Trophy";
import { mapGetters } from "vuex";

export default {
  name: "TheTrophyList",
  components: { Trophy },
  computed: {
    ...mapGetters(["me"]),
  },
  methods: {
    goto(s) {
      this.$store.dispatch("toggleProfileExpanded");
      this.$router.push("/" + s.slug);
    },
  },
};
</script>

<style lang="scss" scoped>
.the-trophy-component {
  background: $green;
  padding: 15px 10px 20px 15px;
  border-bottom: 5px solid #ffffff;

  h2 {
    color: #fff;
    width: 100%;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .trophy-list-container {
    /*min-height: 200px;*/
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;

    .trophy {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      max-width: 50%;
      margin: 10px 0;
      flex: 1 0 auto;
      overflow: hidden;

      &:hover {
        background: $blue;
      }
    }

    p {
      color: #ffffff;
    }
  }
}
</style>
